@if (displayTemplate()) {
  @switch (attachmentPosition()?.tag) {
    @case ('ZalacznikA') {
      <p>
        Pobierz formularz:&nbsp;
        <a title="Pobierz: Zalacznik_A.pdf" href="/templates/Zalacznik_A.pdf" download>
          <strong>Zalacznik_A.pdf</strong>
        </a>
      </p>
      <br>
    }
    @case ('ZalacznikB') {
      <p>
        Pobierz formularz:&nbsp;
        <a title="Pobierz: Zalacznik_B.pdf" href="/templates/Zalacznik_B.pdf" download>
          <strong>Zalacznik_B.pdf</strong>
        </a>
      </p>
      <br>
    }
    @case ('ZalacznikC') {
      <p>
        Pobierz formularz:&nbsp;
        <a title="Pobierz: Zalacznik_C.pdf" href="/templates/Zalacznik_C.pdf" download>
          <strong>Zalacznik_C.pdf</strong>
        </a>
      </p>
      <br>
    }
    @case ('ZalacznikD') {
      <p>
        Pobierz formularz:&nbsp;
        <a title="Pobierz: Zalacznik_D.pdf" href="/templates/Zalacznik_D.pdf" download>
          <strong>Zalacznik_D.pdf</strong>
        </a>
      </p>
      <br>
    }
    @case ('ZalacznikE') {
      <p>
        Pobierz formularz:&nbsp;
        <a title="Pobierz: Zalacznik_E.pdf" href="/templates/Zalacznik_E.pdf" download>
          <strong>Zalacznik_E.pdf</strong>
        </a>
      </p>
      <br>
    }
  }
}
